import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  class: "modal",
  style: {"width":"500px"}
}
const _hoisted_7 = { class: "modal__header" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "modal__header--title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-invoice" }),
  /*#__PURE__*/_createTextVNode(" Create Site ")
], -1)
const _hoisted_9 = { class: "modal__content" }
const _hoisted_10 = { class: "form-field__outline--control" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "site-name",
  class: "form-field__outline--control__label"
}, "Site Name", -1)
const _hoisted_12 = { class: "form-field__outline--control" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "site-url",
  class: "form-field__outline--control__label"
}, "Site Url", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text--style-italic" }, "Copy and Paste your domain address from your website URL for accuracy. Correct Format: https://www.abc.com", -1)
const _hoisted_15 = { class: "modal__footer" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_outline = _resolveDirective("outline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("i", {
          class: "fa fa-times modal__header--clear",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        })
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createSite && _ctx.createSite(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-field form-field__outline ma--bottom-2", {
              'form-field__outline--invalid': _ctx.v$.request.siteName.$error,
              'form-field__outline--active': !_ctx.v$.request.siteName.$invalid,
            }])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-field__outline--control__input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.siteName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.request.siteName],
                [_directive_outline]
              ]),
              _hoisted_11
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-field form-field__outline", {
              'form-field__outline--invalid': _ctx.v$.request.siteUrl.$error,
              'form-field__outline--active': !_ctx.v$.request.siteUrl.$invalid,
            }])
          }, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-field__outline--control__input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.siteUrl) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkUrlIfValid(_ctx.v$.request.siteUrl.$invalid)))
              }, null, 544), [
                [_vModelText, _ctx.request.siteUrl],
                [_directive_outline]
              ]),
              _hoisted_13
            ])
          ], 2),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.fieldsError)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "color--primary-red text--weight-bold text--align-center pa--y-1 pa--right-1",
                innerHTML: _ctx.fieldsMessage
              }, null, 8, _hoisted_16))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn--primary",
            disabled: _ctx.fieldsError
          }, "Create", 8, _hoisted_17)
        ])
      ], 32)
    ])
  ]))
}